
/*
So the issue comes in that cache version (cv) get hardcoded at nuxt server startup,
using this function aligns client & server to use the same cv, with reasonable
3 minute cache time to the storyblok CDN.
see: https://www.storyblok.com/docs/concepts/caching
*/

export function useCachedStoryblok() {
	let CACHE_SECONDS = 3 * 60

	const fetchStory = async (urlPath, options, current_cv) => {
		const { data } = await storyblokApi.get(urlPath, {
	    	...options,
	    	cv: current_cv
	  	})
	  	return data
	}

	const get = async (urlPath, options = {}, cacheKey = null) => {
		const config = useRuntimeConfig()
	  	let current_cv = Math.floor(Date.now() / CACHE_SECONDS * 1000) * CACHE_SECONDS
	  	if (config.public.storyblokVersion != "published") {
	  		// if not published we set CV to 1 second.
	  		current_cv = Math.floor(Date.now() / 1000)
	  	}
		return await fetchStory(urlPath, options, current_cv)
	}

	return {
		CACHE_SECONDS,
		get,
		fetchStory
	}
}
